// import request from '@/router/axios'
import {request } from '@/network/request'
// export function fetchList(query) {
//   return request({
//     url: '/gaoligong//dynamic/getFrontDynamic',
//     method: 'get',
//     params: query
//   })
// }

// export function fetchList(query) {
//   return request({
//     url: '/gaoligong/dynamic/getNotPermissionsDynamic',
//     method: 'get',
//     params: query
//   })
// }
export function fetchList(query) {
  return request({
    url: '/gaoligong/dynamic/getDynamicHome',
    // getDynamicHome
    method: 'get',
    params: query
  })
}
export function addObj(obj) {
  return request({
    url: '/gaoligong/dynamic',
    method: 'post',
    data: obj
  })
}

//查看详情
export function getObj(id) {
  return request({
    url: '/gaoligong/dynamic/' + id,
    method: 'get'
  })
}

export function delObj(id) {
  return request({
    url: '/gaoligong/dynamic/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/gaoligong/dynamic',
    method: 'put',
    data: obj
  })
}
